// Wrapper Component for the Mantine Checkbox
import { ReactElement } from 'react';
import { Checkbox as MantineCheckbox } from '@mantine/core';

// Link to Mantine Checkbox Component:  https://mantine.dev/core/checkbox/
type Props = {
  id: string,
  label?: string,
  isChecked: boolean,
  onChange: (e: any) => void,
  color?: string,
}

export function Checkbox({
  id,
  label,
  isChecked,
  onChange,
  color = '#297B03',
}: Props): ReactElement {
  return (
    <MantineCheckbox
      id={id}
      label={label}
      checked={isChecked}
      onChange={(e) => onChange(e)}
      styles={{
        label: {
          fontWeight: 'unset',
        },
        input: {
          '&:checked': {
            backgroundColor: `${color}`,
            borderColor: `${color}`,
          },
        },
      }}
    />
  );
}
